import { useEffect, useMemo, useRef } from "react";

const useDebounce = (func, wait) => {
  const timerId = useRef(null);
  const funcRef = useRef(func);
  const mounted = useRef(true);

  useEffect(() => {
    funcRef.current = func;
  }, [func]);

  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);

  const debounced = useMemo(() => {
    const invokeFn = (args) => {
      if (mounted.current) {
        funcRef.current(...args);
      }
    };
    const func = (...args) => {
      if (timerId.current) {
        clearTimeout(timerId.current);
      }

      if (mounted.current) {
        timerId.current = setTimeout(() => invokeFn(args), wait);
      }
    };

    func.cancel = () => {
      if (timerId.current) {
        clearTimeout(timerId.current);
      }
    };

    return func;
  }, [wait]);

  return debounced;
};

export default useDebounce;
